import i18n from 'i18n';

const errorNeedAlert: number[] = [
  400010, 401010, 400013, 403010, 404010, 404012, 406010, 4001700, 4001701
];
const hasI18n = [
  /* System/Service level */
  400000,
  401000,
  403000,
  404000,

  405000,
  408000, // 'Connection Time out',
  409000, // 'Conflict',

  500000, // 'Unknown Error',

  /* Role level 500 */
  401500, // 'Function not authorized',
  402500, // 'No actor in used or using invalid actor',

  /* Resource level 600 */
  400600, // 'Invalid operation',
  404600, // 'Resource not found',

  /* Account level 010 */
  400010, // 'Email already in use',
  400013,
  401010, // 'Account not login',
  403010, // 'Account cannot access the resource',
  404010, // 'Account not found',
  404012, // 'Token invalid',
  406010, // 'Account is disable',

  /* Company Level 020 */
  404020, // 'Company not found',

  /* Agency Level 030 */
  400030,
  404030,
  400031,
  400033,

  /* Advertiser Level 040 */
  404040,

  /* AdsOrder Level 050 */
  400050,
  404050,
  409050,

  /* Campaign Level 060 */
  404060,
  400061,
  404062,

  /* Creative Level 070 */
  400070,
  400071,
  400072,
  400073,
  404070,
  400074,
  400075,
  400076,
  400077,

  /* AdXCreativeReview Level 080 */
  400080,
  408080,

  /* Segment Level 090 */
  404090,
  404091,

  /* Common Level 100 */
  400100,

  /* Conversion Level 110 */
  404110,
  404111,

  /* Conversion Level 110 */
  404120,
  400120,

  500080,
  500081,

  /* 3th party 900 */
  401900,

  /* PVMax 910 */
  500910,
  /* IMax 920 */
  500920,
  500921,
  500922,
  500923,

  /* Yahoo 950 */
  401950,
  /* Yahoo Gemini */
  500951,
  500952,
  /* Google API 960 */
  500960,
  500961,

  /* Azure  970 */
  500970,
  401970,
  /* Azure - mediaService 971 */
  500971,

  /* DMP 980 */
  500980,
  500981,
  500982,
  500983,
  500984,
  500985,
  500986,
  500987,

  /* Beacon Connection */
  4001700,
  4001701,

  /* Channel group brand settings */
  4001605, // brand name invalid
  4001606, // brand url invalid
  4001607, // map icon type not allowed, or the uploaded file is missing
  4001608, // map icon too large
  4001609 // map icon svg contains disallowed content
];
const formatters = {
  // ECOPD-5471: 後端跨 repo 契約，訊息格式固定為
  //   "Outdoor video codec illegal, detected=<CODEC>; allowed=<C1, C2>"
  // 解析出偵測到的編碼 (detected=) 與該渠道允許的編碼清單 (allowed=)，分別以
  // {{codec}} / {{allowed}} 帶入 i18n。找不到欄位時退回舊行為（取最後一個 token）。
  400076: (message: string, errorCode: number) => {
    const detectedMatch = message.match(/detected=([^;]*)/);
    const allowedMatch = message.match(/allowed=(.*)$/);
    const messageTokens = message.split(' ');
    const codec = detectedMatch
      ? detectedMatch[1].trim()
      : messageTokens[messageTokens.length - 1];
    const allowed = allowedMatch ? allowedMatch[1].trim() : '';
    return i18n.t(`serverResponse.${errorCode}`, {
      codec,
      allowed
    });
  }
};

export const getServerErrorMessageConfig = (
  errorCode: number,
  defaultMessage: string = i18n.t('serverResponse.500000')
) => {
  let formatter = formatters[errorCode];
  if (formatter) {
    return {
      message: formatter(defaultMessage, errorCode),
      showAlert: errorNeedAlert.indexOf(errorCode) !== -1
    };
  }

  return {
    message:
      errorCode !== 500000 &&
      hasI18n.includes(errorCode) &&
      i18n.exists(`serverResponse.${errorCode}`)
        ? i18n.t(`serverResponse.${errorCode}`)
        : defaultMessage,
    showAlert: errorNeedAlert.indexOf(errorCode) !== -1
  };
};
